import { lazy } from "react"

export const Login = lazy(() => import("./Login").then((m) => ({ default: m.Login })))
export const MiniApp = lazy(() => import("./MiniApp").then((m) => ({ default: m.MiniApp })))
export const Setup = lazy(() => import("./Setup").then((m) => ({ default: m.Setup })))
export const ForgotPassword = lazy(() =>
  import("./ForgotPassword").then((m) => ({ default: m.ForgotPassword })),
)
export const ResetPassword = lazy(() =>
  import("./ResetPassword").then((m) => ({ default: m.ResetPassword })),
)
export const SetupPassword = lazy(() =>
  import("./SetupPassword").then((m) => ({ default: m.SetupPassword })),
)

export const Dashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.Dashboard })))
export const Reports = lazy(() => import("./Reports").then((m) => ({ default: m.Reports })))
export const Orders = lazy(() => import("./Orders").then((m) => ({ default: m.Orders })))
export const Customers = lazy(() =>
  import("./Customers").then((m) => ({ default: m.Customers })),
)
export const CustomerDetail = lazy(() =>
  import("./CustomerDetail").then((m) => ({ default: m.CustomerDetail })),
)
export const OrderDetail = lazy(() =>
  import("./OrderDetail").then((m) => ({ default: m.OrderDetail })),
)
export const OrderEditor = lazy(() =>
  import("./OrderEditor").then((m) => ({ default: m.OrderEditor })),
)
export const Jobs = lazy(() => import("./Jobs").then((m) => ({ default: m.Jobs })))
export const Issues = lazy(() => import("./Issues").then((m) => ({ default: m.Issues })))
export const IssueDetail = lazy(() =>
  import("./IssueDetail").then((m) => ({ default: m.IssueDetail })),
)
export const SalesPoints = lazy(() =>
  import("./SalesPoints").then((m) => ({ default: m.SalesPoints })),
)
export const SalesPointDetail = lazy(() =>
  import("./SalesPointDetail").then((m) => ({ default: m.SalesPointDetail })),
)
export const Channels = lazy(() => import("./Channels").then((m) => ({ default: m.Channels })))
export const Nomenclature = lazy(() =>
  import("./Nomenclature").then((m) => ({ default: m.Nomenclature })),
)
export const NomenclatureDetail = lazy(() =>
  import("./NomenclatureDetail").then((m) => ({ default: m.NomenclatureDetail })),
)
export const SyncRuns = lazy(() => import("./SyncRuns").then((m) => ({ default: m.SyncRuns })))
export const TelegramBots = lazy(() =>
  import("./TelegramBots").then((m) => ({ default: m.TelegramBots })),
)
export const Users = lazy(() => import("./Users").then((m) => ({ default: m.Users })))
export const DocumentCreate = lazy(() =>
  import("./DocumentCreate").then((m) => ({ default: m.DocumentCreate })),
)
export const DocumentHistory = lazy(() =>
  import("./DocumentHistory").then((m) => ({ default: m.DocumentHistory })),
)
export const DocumentHistoryDetail = lazy(() =>
  import("./DocumentHistoryDetail").then((m) => ({ default: m.DocumentHistoryDetail })),
)
export const StoreMappings = lazy(() =>
  import("./StoreMappings").then((m) => ({ default: m.StoreMappings })),
)
export const ReferenceData = lazy(() =>
  import("./ReferenceData").then((m) => ({ default: m.ReferenceData })),
)
export const ApiTokens = lazy(() =>
  import("./ApiTokens").then((m) => ({ default: m.ApiTokens })),
)
export const CatalogValidation = lazy(() =>
  import("./CatalogValidation").then((m) => ({ default: m.CatalogValidation })),
)
